

import { useTranslation } from "react-i18next";
import { Button, Table, TableContainer, TableHead, TableRow, TableCell, Checkbox, TableBody, Paper, MenuList, ListItemIcon, ListItemText, Tooltip, Snackbar, Alert, CircularProgress, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CommonGrid from "../CommonGrid";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import ContextMenu from "../../ContextMenu/ContextMenu";
import { MenuItem } from "semantic-ui-react";
import { ContentCopy } from "@mui/icons-material";
import ErrorModal from "../../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import ConfirmModal from "../../ItemProperties/Forms/FieldDataValidation/ConfirmModal";
import TableLoading from "../../Save/TableLoading";
import LightTooltip from "../../../commonComponents/LightTooltip";

export default function DataDepotTable({ 
  dataDepotList, 
  setDataDepotList, 
  dataDepotFieldList,
  setDataDepotFieldList,
  dataDepotSelected, 
  setDataDepotSelected, 
  actionQueue, 
  setActionQueue, 
  fetchDDFields,
  fetchDDList,
  ddAdded,
  setDdAdded,
  saveFromConfirmModal,
  postSaveSelect,
  setPostSaveSelect,
  newCopyDD,
  setNewCopyDD,
  setPreventDdfFetch
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [gridApi, setGridApi] = useState();
  const [ddRows, setDdRows] = useState([]);
  const [connectionName, setConnectionName] = useState('');
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [confirmSaveModal, setConfirmSaveModal] = useState(false);
  const [confirmSaveMessage, setConfirmSaveMessage] = useState('');
  const [confirmSaveInfo, setConfirmSaveInfo] = useState(false)
  const [loadingActive, setLoadingActive] = useState(false);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [successSnackbarMsg, setSuccessSnackbarMsg] = useState('');
  const [copyDataDepotModal, setCopyDataDepotModal] = useState(false);
  const [copyInput, setCopyInput] = useState(false);
  const [copyInputError, setCopyInputError] = useState(false);
  const [copyFinishDisabled, setCopyFinishDisabled] = useState(true);
  const [confirmButtonsDisabled, setConfirmButtonsDisabled] = useState(false);
  
  const { account } = useSelector((state) => state.queryParams);
  // const [dataDepotList, setDataDepotList] = useState([]);\
  
  const addNewAfterHandler = (e, rowIndex) => {
    let nodeInfo = e.api.getRowNode(rowIndex);
    nodeInfo.setSelected(true);
  }

  const gridOptions = {
    columnDefs: [
      {
        addNewControl: true,
        addControlLabel: t('BTN_NEW_DATA_DEPOT'),
        addNewAfterHandler: addNewAfterHandler,
        headerName: t('LBL_DATA_DEPOT_NAME'),
        field: 'value',
        editable: (params) => params.data.value === "",
        cellRenderer: (info) => CustomCellRenderer(info, connectionName),
        cellStyle: {paddingRight: "5px", borderRight: 'none'},
      },
    ],
    rowSelection: 'single',
    suppressRowDeselection: true,
    onCellEditingStopped: (e) => handleEditStop(e),
  };

  const scrollToFocusedCell = () => {
    const focusedCell = gridApi.getFocusedCell();
    const rowIndex = focusedCell?.rowIndex;
    const columnId = focusedCell?.column?.colId;
    try {
      gridApi?.ensureIndexVisible(rowIndex + 1);
      gridApi?.scrollToColumn(columnId);
    } catch (err) {}
  };

  const handleRowAddSuccess = (response, val) => {
    // on Data Depot add, don't fetch ddlist. Set selected so user can add fields to new DD.
    setDataDepotSelected(val);
    // setSuccessSnackbarMsg(`${t('SUCCESSFULLY_DELETED_DATA_DEPOT')} ${val}`);
    // setShowSuccessSnackbar(true);
    scrollToFocusedCell();
  }

  const handleRowAddFailure = (response, val) => {
    // console.log(response);
  }

  const requestRowAdd = (val) => {
    setDdAdded(val);
    setDataDepotList(prev => [...prev.map(a => a === "" ? val : a), ''])
    
    setLoadingActive(true);
    dispatch(api.endpoints.addDataDepot.initiate({
      account: account,
      depotName: val
    }, {forceRefetch: true})).then(response => {
      if (response?.data?.current_state && response?.data?.current_state === "SUCCESS") {
        handleRowAddSuccess(response, val)
      } else {
        handleRowAddFailure(response, val)
      }
    }).catch(err => handleRowAddFailure(err))
    .finally(() => {
      setLoadingActive(false);
    })
  }

  const handleRowEditSuccess = (response, val) => {
    // console.log(response, val);
  }

  const handleRowEditFailure = (response, val) => {
    // console.log(response);
  }

  const requestRowEdit = (val, newVal) => {
    setLoadingActive(true);
    dispatch(api.endpoints.editDataDepot.initiate({
      account: account,
      depotName: val,
      newDepotName: newVal
    }, {forceRefetch: true})).then(response => {
      if (response?.data?.current_state && response?.data?.current_state === "SUCCESS") {
        handleRowEditSuccess(response, val)
      } else {
        handleRowEditFailure(response, val)
      }
    }).catch(err => handleRowEditFailure(err))
    .finally(() => {
      setLoadingActive(false);
    })
  }

  const handleNewRowCreation = (val) => {
    requestRowAdd(val);
  }

  const handleEditRow = (val, newVal) => {
    //console.log(val, newVal);
    //edit endpoint not yet created.
    // requestRowEdit(val, newVal);
  }

  //triggers when editing is stopped. may be useful in the future.
  const handleEditStop = (e) => {}

  //triggers when cell value changes. runs before edit stop.
  const handleCellValueChanged = (e) => {
    if (e.newValue !== "") {
      validateDdName(e.newValue, (errMsg) => {
        if (errMsg) {
          //if name not valid, prevent add request, and show err modal.
          if (errMsg === "DATA_DEPOT_NAME_ALREADY_EXISTS") setPreventDdfFetch(true);
          setDataDepotSelected(false);
          setDataDepotList(prev => prev.map((v, i) => i === prev.length - 1 ? '' : v));
          setErrorMessage(t(errMsg));
          setErrorModalOpen(true);
        } else {
          handleNewRowCreation(e.newValue);
        }
      });
    }
  }

  const handleRowSelect = (val, e, fromFocus) => {
    if (fromFocus || e.target?.dataset?.type === 'row-el') setDataDepotSelected(val);
  }

  const handleSuccessSnackbarClose = () => {
    setSuccessSnackbarMsg('');
    setShowSuccessSnackbar(false);
  }

  const CustomCellRenderer = (info, val) => {
    const { value, data } = info;
    const [openModal, setOpenModal] = useState(false);
    const [message, setMessage] = useState("");
    
    const handleDeleteClick = () => {
      const message = t("BOX_ARE_YOU_SURE_YOU_WANT_TO_DEL_")
        .split("{0}")
        .map((e, i) => {
          return i === 0 ? (
            <span key={'ddRow-' + e + '-' + i}>{e}</span>
          ) : (
            <div className="inline" key={'ddRow-' + e + '-' + i}>
              {" "}
              <span key={'ddRowMsg-' + e + '-' + i} style={{ fontWeight: "600" }}>
                {" "}
                {value || ""}{" "}
              </span>{" "}
              <span key={'ddRow-' + e + '-' + i}>{e}</span>{" "}
            </div>
          );
        });
      setMessage(message);
      setOpenModal(true);
    };

    const handleCopyClick = (val) => {
      requestRowCopy(val)
    }

    const handleDeleteSuccess = (response, val) => {
      fetchDDList();
      setOpenModal(false);
      setDataDepotSelected(false);
      setDataDepotFieldList([]);
      setSuccessSnackbarMsg(`${t('SUCCESSFULLY_DELETED_DATA_DEPOT')} ${val}`);
      setShowSuccessSnackbar(true);
    }
  
    const handleDeleteFailure = (response) => {
      setErrorMessage(t('BOX_ERR_SAVING_DATA_DEPOT'));
      setOpenModal(false);
      setErrorModalOpen(true);
      setDataDepotSelected(false);
      setDataDepotFieldList([]);
      fetchDDList();
    }

    const requestRowCopy = (val) => {
      setCopyInput(t('FRG_COPY_OF_').replace(' ', '_') + '_' + val);
      setCopyDataDepotModal(true);
    }
  
    const requestRowDelete = (val) => {
      setLoadingActive(true);
      dispatch(api.endpoints.deleteDataDepot.initiate({
        account: account,
        depotName: val
      }, {forceRefetch: true})).then(response => {
        if (response?.data?.current_state && response?.data?.current_state === "SUCCESS") {
          handleDeleteSuccess(response, val)
          setActionQueue((prev) => {
            return prev.filter((a) => a !== val)
          })
        } else {
          handleDeleteFailure(response, val)
        }
      }).catch(err => handleDeleteFailure(err))
      .finally(() => {
        setLoadingActive(false);
      })
    }

    const deleteHandler = (value) => {
      requestRowDelete(value);
    };

    return (
      <div
        key={`ddModalDiv-${value}`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: '2rem',
          cursor: "pointer"
        }}
        onClick={(e) => {
          // handleRowSelect(value, e)
        }}
        data-type="row-el"
      >
        {!value || /^\s*$/.test(value) ? (
          <span style={{ color: "#0000008A"}} data-type="row-el">{t('BTN_NEW_DATA_DEPOT')}</span>
        ) : value.length > 32 ? (
          <LightTooltip
            title={value}
            arrow
            data-type="row-el"
            placement="right"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, 40],
                    },
                  },
                ],
              },
            }}
          >
            <div data-type="row-el" style={styles.rowText}>{value}</div>
          </LightTooltip>
          
        ) : (
          <div data-type="row-el" style={styles.rowText}>{value}</div>
        )}
        {data?.key || data?.value ? (
          <div className="flex align-center" data-type="row-el">
            <LightTooltip
              title={t('DELETE')}
              arrow
              data-type="row-el"
            >
              <span style={{ cursor: 'pointer', fontSize: '22px' }} className="DELETE" onClick={() => handleDeleteClick(value)}></span>
            </LightTooltip>
            <LightTooltip
              title={t('MNU_COPY')}
              arrow
              data-type="row-el"
            >
              <span style={{ cursor: 'pointer', fontSize: '22px' }} className="FILE_COPY" onClick={() => handleCopyClick(value)}></span>
            </LightTooltip>
          </div>
        ) : (
          ""
        )}
        <ConfirmModal
          key={`ddModalModal-${value}`}
          openModal={openModal}
          message={message}
          onClose={() => setOpenModal(false)}
          yesHandler={(e) => {
            deleteHandler(value, e);
          }}
          noHandler={() => setOpenModal(false)}
        />
        {loadingActive && (<Spinner />)}
      </div>
    );
  };

  const appendAction = (type, data) => {
    // console.log(type, data);
  }

  const handleRow = (options) => {
    options.api.refreshCells({
        force: true,
        suppressFlash: false,
    });
  }

  const handleCellFocused = (e, modalClose) => {
    let nodeInfo = e.api.getRowNode(e.rowIndex);
    let val = nodeInfo.data.value;

    //case, user has been asked to confirm save unsaved changes from previous selected Data Depot
    if (modalClose) {
      if (modalClose === 'yes') {
        saveFromConfirmModal(val);
      }
      if (modalClose === 'no') {
        nodeInfo.setSelected(true);
        handleRowSelect(nodeInfo.data.value, null, true);
        setActionQueue([]);
        setConfirmSaveModal(false);
      }
      // return;
    }

    if (dataDepotSelected === undefined) {
      nodeInfo.setSelected(true);
      handleRowSelect(nodeInfo.data.value, null, true);
    } else {
      if (val !== dataDepotSelected && actionQueue.length > 0) {
        if (confirmSaveModal) {
          setConfirmSaveModal(false);
          nodeInfo.setSelected(true);
          handleRowSelect(nodeInfo.data.value, null, true);
        } else {
          let msgSplit = t('THERE_ARE_UNSAVED_CHANGES_MADE_TO').split('{0}');
          let message = (
            <div>
              {msgSplit[0]} {'('}<b>{actionQueue.length}</b>{')'} {msgSplit[1]} <span className="bold">{dataDepotSelected}</span> <br/><br/>
              {t('DO_YOU_WANT_TO_SAVE_THESE_CHANGES')}?
            </div>
          )
          setConfirmSaveInfo(e);
          setConfirmSaveMessage(message);
          setConfirmButtonsDisabled(false);
          setConfirmSaveModal(true);
        }
        
      } else {
        nodeInfo.setSelected(true);
        handleRowSelect(nodeInfo.data.value, null, true);
      }
    } 
  }

  const handleConfirmSaveYes = (e) => {
    setConfirmButtonsDisabled(true);
    handleCellFocused(confirmSaveInfo, 'yes');
    setConfirmSaveModal(false);
  }

  const handleConfirmSaveNo = (e) => {
    setConfirmButtonsDisabled(true);
    handleCellFocused(confirmSaveInfo, 'no');
    setConfirmSaveModal(false);
  }

  const handleCopySuccess = (response) => {
    fetchDDList(copyInput, true);
    setDataDepotSelected(copyInput);
    setCopyInput('');
    setCopyInputError('');
  }
  const handleCopyFailure = (response) => {
    //need user feedback for the failure
  }

  const handleCopyFinish = (e) => {
    //send request to copy.
    dispatch(api.endpoints.copyDataDepot.initiate({
      account: account,
      depotName: dataDepotSelected,
      newDepotName: copyInput
    }, {forceRefetch: true})).then(response => {
      if (response?.data?.current_state && response?.data?.current_state === "SUCCESS") {
        handleCopySuccess(response)
      } else {
        //handleCopyFailure(response, val)
      }
    }).catch(err => handleCopyFailure(err))
    .finally(() => {
      setLoadingActive(false);
    });
    setCopyDataDepotModal(false);
  }

  const handleCopyCancel = (e) => {
    //clear copy states, close modal
    setCopyInput('');
    setCopyInputError('');
    setCopyDataDepotModal(false);
  }

  const validateDdName = (text, callback) => {
    if (!text.length) return callback('BOX_ERR_EMPTY_DD_FIELD_NAME')
    
    //name already exists
    if (dataDepotList.filter((a, b) => {
      return a.toLowerCase() === text.toLowerCase();
    }).length) {
      return callback('DATA_DEPOT_NAME_ALREADY_EXISTS');
    }

    //only alphanumeric, underscore, dash
    if (!/^[a-zA-Z0-9-_]+$/.test(text)) {
      return callback('BOX_ERR_INVALID_DD_NAME');
    }

    //char limit 45
    if (text.length > 45) {
      return callback('BOX_ERR_DD_NAME_EXCEED_LIMIT');
    }

    return callback(false);
  }
  
  useEffect(() => {
    if (postSaveSelect) {
      handleCellFocused(confirmSaveInfo);
      setConfirmSaveModal(false);
      setPostSaveSelect(false);
    } else if (postSaveSelect === "") {
      setConfirmSaveModal(false);
    }
  }, [postSaveSelect])

  useEffect(() => {
    if (ddAdded) {
      //timeout because can't find a working "onReady" event for ag-grid rows.
      setTimeout(() => {
        gridApi.forEachNode(node => {
          if (node.data.value === ddAdded) {
            node.setSelected(true);
            node.setHighlighted(true);
          }
        })
        setDataDepotSelected(ddAdded);
      }, 200)
    }
    if (dataDepotList) {
      setDdRows(dataDepotList.map((o, i) => {
        return {
          id: `ddRow-${i}`,
          value: o
        }
      }));
    } else {
      fetchDDList();
    }
  }, [dataDepotList]);

  useEffect(() => {
    if (newCopyDD && gridApi) {
      let rows = gridApi.getRenderedNodes();
      let node = rows.filter(o => o.data.value === newCopyDD)[0];
      if (node) {
        node.setSelected(true);
        node.setHighlighted(true);
        gridApi.ensureIndexVisible(node.rowIndex, null);
      } else {
        //fallback incase rows arent generating on time... this will need to be improved
        setTimeout(() => {
          rows = gridApi.getRenderedNodes();
          node = rows.filter(o => o.data.value === newCopyDD)[0];
          if (node) {
            node.setSelected(true);
            node.setHighlighted(true);
            gridApi.ensureIndexVisible(node.rowIndex, null);
          } else {
            // dev message for future debugging of odd edge case
            console.warn('new node not found in rows arr: ', rows, newCopyDD);
          }
        }, 100)
      }
      setNewCopyDD(false);
    }
  }, [gridApi])

  useEffect(() => {
    validateDdName(copyInput, (errMsg) => {
      if (errMsg) {
        setCopyInputError(t(errMsg));
        setCopyFinishDisabled(true);
      } else {
        setCopyInputError('');
        setCopyFinishDisabled(false);
      }
    })
  }, [copyInput])

  return (
    <>
      <div id="ddTableContainer" style={{height: "100%"}}>
        <CommonGrid
          gridOptions={gridOptions}
          rowData={ddRows}
          containerStyle={styles.gridStyle}
          getGridAPI={(gridOptions, gridApi) => {
            setGridApi(gridApi.api)
          }}
          gridProps={{
            onRowClicked: handleRow,
            onCellValueChanged: handleCellValueChanged,
            onCellFocused: handleCellFocused,
          }} 
          emptyText={t('BTN_NEW_DATA_DEPOT')}
        />
        <ErrorModal
          errorModal={errorModalOpen}
          setErrorModal={setErrorModalOpen}
          errorMessage={errorMessage}
          handleErrorModal={setErrorModalOpen}
        />
        <Snackbar
          open={showSuccessSnackbar}
          autoHideDuration={3000}
          onClose={handleSuccessSnackbarClose}
        >
          <Alert
            onClose={handleSuccessSnackbarClose}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}>
            {successSnackbarMsg}
          </Alert>
        </Snackbar>
        <ConfirmModal
          openModal={confirmSaveModal}
          message={confirmSaveMessage}
          onClose={handleConfirmSaveNo}
          yesHandler={handleConfirmSaveYes}
          noHandler={handleConfirmSaveNo}
          yesDisabled={confirmButtonsDisabled}
          noDisabled={confirmButtonsDisabled}
        />
        <CopyModal
          openModal={copyDataDepotModal}
          dataDepotSelected={dataDepotSelected}
          copyInput={copyInput}
          setCopyInput={setCopyInput}
          dataDepotList={dataDepotList}
          copyInputError={copyInputError}
          copyFinishDisabled={copyFinishDisabled}
          finishHandler={handleCopyFinish}
          cancelHandler={handleCopyCancel}
          onClose={() => setCopyDataDepotModal(false)}
        />
      </div>
    </>
  )
}

function CopyModal(props) {
  const { openModal, dataDepotSelected, copyInput, setCopyInput, dataDepotList, copyInputError, copyFinishDisabled, finishHandler, cancelHandler} = props;
  const { t } = useTranslation();

  return (
      <>
          <Dialog
              open={openModal}
              onClose={props.onClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
          >
              <DialogTitle className='dialog-header'>
                  <div className="title">{t('MNU_COPY') + ' ' + t('DATA_DEPOT')}</div>
              </DialogTitle>

              <DialogContent className='modal-content' dividers>
                {t('ENTER_A_NEW_NAME_FOR_THE_COPY_OF')} <b>{dataDepotSelected}</b> . 
                <TextField
                  id="ddCopyName" 
                  className="width-100 margin-top-12"
                  variant="outlined"
                  size="small"
                  type="text"
                  autoFocus={true}
                  label={t('LBL_NEW_DATA_DEPOT_NAME')}
                  value={copyInput}
                  onChange={(e) => setCopyInput(e.target.value)}
                  error={copyInputError.length > 0}
                  helperText={copyInputError}
                />
              </DialogContent>

              <DialogActions>
                  <Button
                      size="small"
                      onClick={finishHandler}
                      variant={"outlined"}
                      disabled={copyFinishDisabled}
                  >
                      {t("BTN_FINISH")}
                  </Button>
                  <Button
                      size="small"
                      onClick={cancelHandler}
                      variant={"outlined"}
                  >
                      {t("LBL_CANCEL")}
                  </Button>
              </DialogActions>
          </Dialog>
      </>
  )
}

function Spinner() {
  const { t } = useTranslation();
  return (
    <div style={styles.loading} >
        <div style={styles.loadingText}>{t('LOADING_IND')}</div>
        <CircularProgress sx={styles.loadingCircle} color="primary"/>
    </div>
  )
}

const styles = {
  gridStyle: {
    width: "300px", 
    overflowX: "none", 
    height: "100%",
  },
  loadingCircle: { height: '60px !important', width: '60px !important' },
  loadingText: { fontSize: '16px', fontWeight: '500', marginBottom: '8px' },
  loading: {
    position: 'absolute', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    width: '100px',
  },
  rowText: {overflow: 'hidden' },
  addNewContainer: {
    position: 'absolute',
    zIndex: '1',
    width: '275px',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '5px'
  }
}